// todo: move this file to another folder; product is not the owner of this
export default Object.freeze({
  NotAllowed: 'NotAllowed',
  Single: 'Single',
  Multiple: 'Multiple',
})
